export const getGlobal = (get, location) => {
    if (!window.__WDE_GLOBAL_STORE__) {
        window.__WDE_GLOBAL_STORE__ = {};
    }
    const value = window.__WDE_GLOBAL_STORE__[location] || get();
    window.__WDE_GLOBAL_STORE__[location] = value;
    return value;
};
//# sourceMappingURL=global.js.map